import CSVParser from 'papaparse';
var FileProvider = function (title, name, Parser) {
    var provider = function () { return ({
        title: title,
        name: name,
        uploadFile: function (file, fileName) {
            var _this = this;
            return new Promise(function (resolve, reject) {
                var reader = new FileReader();
                reader.onloadend = function () {
                    resolve({
                        storage: 'base64',
                        name: fileName,
                        contents: Parser.parse(reader.result),
                        size: file.size,
                        type: file.type
                    });
                };
                reader.onerror = function () {
                    reject(_this);
                };
                reader.readAsText(file);
            });
        },
        downloadFile: function (file) {
            // Return the original as there is nothing to do.
            return Promise.resolve(file);
        }
    }); };
    provider.title = title;
    return provider;
};
export default {
    csv: FileProvider('CSV', 'csv', CSVParser),
};
